function isDevMode() {
  return !isProdMode();
}

function isProdMode() {
  return process.env.NODE_ENV === 'production';
}

// Exposes the state below window.$ibkng$.[your state] when in develop mode.
export default function makeStoreDebugAccessible(key: string, state: any) {
  if (isDevMode()) {
    const mainKey = '$ibkng$';
    // @ts-ignore
    window[mainKey] = window[mainKey] || {};
    // @ts-ignore
    window[mainKey][key] = state;
  }
}
